/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Granite Bagas
*/

import React, { useState, useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import SociollaText from '@components/sociolla/SociollaText';
import ItemDetail from '@components/global/ItemDetail';
import Colors from '@global/colors';
import Button from '@components/form/Button';
import MapPicker from '@components/form/MapPicker';
import * as Layout from '@components/screen/Layout';
import { isWeb } from '@global/screens';
import { hasNoAccess, parseDate } from '@global/helpers';
import useApi from '@/hooks/useApi';
import { MsAccount } from '@api/ms-account';
import StatusBadge from '@components/global/StatusBadge';
import Image from '@components/global/Image';
import ScrollContainer from '@components/global/ScrollContainer';
import TitleSubSection from '@components/global/TitleSubSection';
import { PKP_TYPES, WHT } from '@/constants';

const SubdistributorDetailScreen = (props) => {
  const [detailData, setDetailData] = useState({});
  const prev_page = props?.route?.params?.prev_page;

  const getOutletDetail = useApi(MsAccount.getOutletDetail);
  const img = require('@/assets/img/default/user-image.png');

  const restrictedRoles = [
    'superadmin',
    'general',
    'regional_manager',
    'regional_support',
    'key_account_manager',
    'group_key_account_manager',
    'national_key_account_manager',
    'marketing_admin',
    'chief_of_staff',
  ];

  const showEditButton = !hasNoAccess(restrictedRoles);

  const getDetail = async (id) => {
    const response = await getOutletDetail.request(id);
    if (response?.data?.data && Object.keys(response.data.data).length) {
      const result = response.data.data;
      result.id = result._id;

      const isPkp = PKP_TYPES.find((v) => v.value == result.tax_is_pkp);
      result.tax_is_pkp = isPkp ? isPkp.name : '';

      const wht = WHT.find((v) => v.value == result.tax_wht);
      result.tax_wht = wht ? wht.label : '';

      setDetailData(result);
    }
  };

  const goBack = () => {
    if (prev_page == 'skp-external') {
      const skpId = props?.route?.params?.skp_id;
      const referenceCode = props?.route?.params?.reference_code;
      props.navigation.navigate('SkpExternalNavigator', {
        screen: 'SkpExternalDetailScreen',
        params: {
          id: skpId,
          titleScreen: referenceCode,
          name: detailData.customer.name,
        },
      });
    } else {
      props.navigation.replace('SubdistributorDetailScreen', {});
      props.navigation.navigate('SubdistributorScreen');
    }
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setDetailData({});
      if (props?.route?.params?.id) {
        getDetail(props.route.params.id);
      }
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  return (
    <Layout.Container>
      {getOutletDetail?.loading ? (
        <Layout.Wrapper>
          <Layout.Loader />
        </Layout.Wrapper>
      ) : detailData && Object.keys(detailData).length ? (
        <>
          {isWeb ? (
            <Layout.Wrapper white={false}>
              <Layout.Back
                title="Sub Distributor"
                onCallback={() => goBack()}
              />
            </Layout.Wrapper>
          ) : (
            false
          )}
          <ScrollContainer>
            <Layout.Wrapper rounded>
              <View style={styles.sectionWrapper}>
                <View
                  style={[
                    styles.rowContainer,
                    {
                      position: 'relative',
                      zIndex: 1,
                      justifyContent: 'space-between',
                    },
                  ]}>
                  <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                    <Image
                      style={{
                        width: 50,
                        height: 50,
                        margin: 10,
                      }}
                      width={50}
                      height={50}
                      isPhoto={true}
                      source={
                        detailData?.customer?.image
                          ? detailData.customer.image
                          : img
                      }
                    />
                    <SociollaText type="medium" style={{ fontSize: 20 }}>
                      {detailData?.customer?.name || ''}
                    </SociollaText>
                  </View>
                  {isWeb && (
                    <View style={{ flexDirection: 'row' }}>
                      {showEditButton ? (
                        <Button
                          type="primary"
                          rounded
                          buttonStyle={{ width: 80, marginRight: 10 }}
                          title={
                            <SociollaText
                              type="bold"
                              style={{ color: Colors.white }}>
                              Edit
                            </SociollaText>
                          }
                          onPress={() =>
                            props.navigation.replace(
                              'SubdistributorFormScreen',
                              {
                                id: detailData._id,
                                name: detailData.customer.name,
                                titleScreen: detailData.customer.name,
                              },
                            )
                          }
                        />
                      ) : (
                        false
                      )}
                    </View>
                  )}
                </View>

                <View
                  style={[
                    { width: '100%' },
                    isWeb ? { paddingVertical: 15 } : { paddingBottom: 20 },
                  ]}>
                  <ItemDetail
                    name="Status"
                    centered
                    value={
                      <StatusBadge
                        status={detailData.is_active ? 'active' : 'in_active'}
                      />
                    }
                  />
                  <ItemDetail
                    name="Last Updated, by"
                    value={`${parseDate(detailData.updated_at)}, ${
                      detailData.updated_by ? detailData.updated_by.name : '-'
                    }`}
                  />
                  <ItemDetail
                    name="Outlet Name"
                    value={detailData.name ? detailData.name : '-'}
                  />
                  <ItemDetail
                    name="Outlet Code"
                    value={detailData.code ? detailData.code : '-'}
                  />
                  <ItemDetail
                    name="Sales Team"
                    value={
                      detailData.sales_team ? detailData.sales_team.name : '-'
                    }
                  />
                  <ItemDetail
                    name="Market Type"
                    value={
                      detailData.market_type ? detailData.market_type.code : '-'
                    }
                  />
                  <ItemDetail
                    name="Business Type"
                    value={
                      detailData.business_type
                        ? `${detailData.business_type.code} (${detailData.business_type.description})`
                        : '-'
                    }
                  />
                  <ItemDetail
                    name="Country ID"
                    value={detailData.country ? detailData.country.name : '-'}
                  />
                  <ItemDetail
                    name="State ID"
                    value={detailData.state ? detailData.state.name : '-'}
                  />
                  <ItemDetail
                    name="City"
                    value={detailData.city ? detailData.city.name : '-'}
                  />
                  <ItemDetail
                    name="Location"
                    {...(detailData?.lat_long?.latitude &&
                    detailData?.lat_long?.longitude
                      ? {
                          valueComponent: (
                            <MapPicker
                              value={detailData?.lat_long}
                              hideInput={true}
                              disabled={true}
                              editable={false}
                              containerStyle={{
                                marginTop: 14,
                                borderRadius: 4,
                                width: '50%',
                              }}
                            />
                          ),
                        }
                      : {
                          value: '-',
                        })}
                  />
                  <ItemDetail
                    name="Street"
                    value={detailData.street ? detailData.street : '-'}
                  />

                  <TitleSubSection
                    title={'TAX IDENTIFICATION'}
                    style={{ marginVertical: 10 }}
                  />
                  <ItemDetail
                    name="Name"
                    value={detailData.tax_name ? detailData.tax_name : '-'}
                  />
                  <ItemDetail
                    name="Number"
                    value={detailData.tax_number ? detailData.tax_number : '-'}
                  />
                  <ItemDetail
                    name="Taxable Entrepreneur"
                    value={detailData.tax_is_pkp ? detailData.tax_is_pkp : '-'}
                  />
                  <ItemDetail
                    name="WHT (Corporate/Personal)"
                    value={detailData.tax_wht ? detailData.tax_wht : '-'}
                  />
                </View>
              </View>
            </Layout.Wrapper>
          </ScrollContainer>
        </>
      ) : (
        false
      )}
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  sectionWrapper: { width: '100%', padding: 15 },
  rowContainer: { flexDirection: 'row', alignItems: 'center' },
});

export default SubdistributorDetailScreen;
